import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  handleIconDownload,
} from '../../../helper'
import { selectDataViewByTrend, selectIndicatorById } from '../store/slice'
import Chart from './Chart'

const Trend = ({ isDynamicReport, id, check = [] }) => {
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)

  const chart1 = {
    title: 'financialAnalysis.TOTAL_LIABILITIES_TO_EQUITY',
    dataKey: 'RT0034',
    label: indicatorById['RT0034']?.ratioName,
    color: '#006AA6',
  }

  const chart2 = {
    title: 'financialAnalysis.LOAN_TO_EQUITY',
    dataKey: 'FA084',
    label: indicatorById['FA084']?.ratioName,
    color: '#F49966',
  }

  const isNoData = !dataByTrend.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  const chart = []
  if (!isDynamicReport) {
    chart.push(...[1, 2])
  } else {
    if (check.includes('RT0034')) {
      chart.push(1)
    }
    if (check.includes('FA084')) {
      chart.push(2)
    }
  }

  const isW50 = chart.length === 2

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className="dFlex"
    >
      {chart.includes(1) && (
        <div className="w50 h100 pr2">
          <Chart
            data={dataByTrend}
            propsChart={chart1}
            isDynamicReport={isDynamicReport}
          />
        </div>
      )}
      {chart.includes(2) && (
        <div className={isW50 ? 'w50 h100 pl2' : 'w50 h100'}>
          <Chart
            data={dataByTrend}
            propsChart={chart2}
            isDynamicReport={isDynamicReport}
          />
        </div>
      )}
    </div>
  )
}

export default Trend
